/* Core & libraries */
import React, { useState, useRef, useEffect } from "react";
import { useTheme } from "react-jss";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import { ErrorMessage, Field, Formik } from "formik";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UCButton from "../../buttons";

/* Helpers, constants, custom methods, internal libraries */
import {
  createValidationPolicyYupSchema,
  useValidationService
} from "../../../resources/validations/validations";

/* Components */

/* Styles */
import styles from "./styles.js"
import { colors } from "../../../constants/colors";


const messages = defineMessages({
  policyNamePlaceholderMessage: {
    id: 'createPolicy.policyName'
  },
})

const Content = props => {
  const { setShowModal, handleCreatePolicy, companyEntityId, policyNameError, genericError, resetErrorMessages } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  const formRef = useRef(null);
  const intl = useIntl();

  const { createPolicyMockedValidationObj } = useValidationService()
  const [testSchema, setTestSchema] = useState({});

  useEffect(() => {
    //TODO: api call to get validations //simpleMockedApiValidationObj
    const result = createValidationPolicyYupSchema(createPolicyMockedValidationObj);
    setTestSchema(result)
  }, [])

  const handleFormSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit()
    }
  }

  const submitForm = (values, setSubmitting) => {
    handleCreatePolicy(values)
    setSubmitting(false);
  }

  return (
    <div className={classes.modalContent}>
      <Formik
        innerRef={formRef}
        initialValues={{
          companyEntityId: companyEntityId,
          policyName:"",
        }}
        validationSchema={testSchema}
        onSubmit={(values, { setSubmitting }) => {
          submitForm(values, setSubmitting);
        }}
      >
        {({
          values,
          errors,
          touched,
          setFieldTouched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
            setFieldValue
          }) => (

          <>
            <form onSubmit={handleSubmit} onChange={() => resetErrorMessages()}>
              <div className={classes.inputContainer}>
                <label htmlFor="policyName" className={classes.label}>
                  <FormattedMessage id="createPolicy.name"/>
                </label>
                <Field
                  placeholder={intl.formatMessage(messages.policyNamePlaceholderMessage)}
                  type="policyName"
                  name="policyName"
                  id="policyName"
                  className={
                    (errors.policyName && touched.policyName) || policyNameError || genericError
                      ? "input-error"
                      : null
                  }
                />
                <ErrorMessage
                  name="policyName"
                  component="span"
                  className={classes.error}
                />
                {policyNameError && (
                  <div className={classes.nameError}>
                    <FormattedMessage id="createPolicy.policyNameError" />
                  </div>
                )}
                {genericError && (
                  <div className={classes.nameError}>
                    <FormattedMessage id="validations.generalError" />
                  </div>
                )}
              </div>
              <div className={classes.btnContainer}>
                <ContainerFluid>
                  <Row>
                    <Col className={classes.colCancel}>
                      <UCButton
                        onClick={() => setShowModal(false)}
                        type="default"
                        className={classes.cancelBtn}
                        text={<FormattedMessage id="createPolicy.cancel"/>}
                      />
                    </Col>
                    <Col className={classes.colRemove} >
                      <UCButton
                        className={classes.createBtn}
                        onClick={handleFormSubmit}
                        type="primary"
                        text={<FormattedMessage id="createPolicy.createPolicy"/>}
                        spinner={{
                          name: "createPolicySpinner",
                          size: 20,
                          color: colors.white
                        }}
                      />
                    </Col>
                  </Row>
                </ContainerFluid>
              </div>
            </form>
          </>
        )}
      </Formik>
    </div>
  )
}

export default Content;
